/**
 * Google Ads conversion tracking.
 *
 * The Google Ads gtag library (AW-18170306000) is loaded once globally
 * by ``components/analytics/GoogleAdsTag.js`` on marketing pages. This
 * module just exposes per-event conversion IDs (``send_to`` values from
 * Google Ads Conversion Actions) and a thin helper to fire them.
 *
 * Add new conversion actions in Google Ads
 * (Tools and Settings -> Conversions -> "+ New conversion action") and
 * paste the resulting ``send_to`` value (``<conversion id>/<label>``)
 * here.
 */

export const GOOGLE_ADS_CONVERSIONS = {
  // Fires when a lead-magnet form is successfully submitted.
  DOWNLOAD_COMPLETE: 'AW-18170306000/yY1ECLDst68cENC7o9hD',
};

/**
 * Send a Google Ads conversion event.
 *
 * Safe to call even when the gtag library hasn't loaded (e.g. ad blockers
 * present, or page is below the cookie-consent threshold) -- the call
 * is silently a no-op.
 *
 * @param {string} sendTo - Full conversion send-to value (``<id>/<label>``).
 */
export function trackGoogleAdsConversion(sendTo) {
  if (!sendTo) return;
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', 'conversion', { send_to: sendTo });
  } catch (_) {
    // Tracking is best-effort; never throw upstream.
  }
}
